module.exports = __webpack_public_path__ + "static/media/infoIcon.bbb4463c.svg";